<template>
  <teleport to="body">
    <div id="spinner" class="spinner-container d-none">
      <div class="spinner"></div>
    </div>
  </teleport>
</template>

<style>
/* Estilo para el contenedor del spinner */
.spinner-container {
  position: fixed;
  inset: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999999;
}

/* Scoped al spinner: un .d-none global pisaba los d-md-flex/d-md-block de Bootstrap en toda la app */
.spinner-container.d-none {
  display: none !important;
}

/* Estilo para el spinner */
.spinner {
  border: 4px solid #ffffff;
  border-top: 4px solid var(--primary-color);
  border-radius: 50%;
  width: 50px;
  height: 50px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>
